var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showPreviewOptionsFlag
    ? _c(
        "div",
        {
          staticClass: "preview-options",
          staticStyle: {
            "box-shadow":
              "0 0 8px 0 rgb(188 189 191), 0 2px 4px 0 rgb(204 205 208)",
            width: "70px",
            "text-align": "center",
            "margin-left": "10px",
            position: "fixed",
            "z-index": "9999",
            "font-size": "12px",
            "border-radius": "4px",
            background: "#fff",
          },
          style: {
            left: _vm.bigImgClickPostion.pageX + "px",
            top: _vm.bigImgClickPostion.pageY + "px",
          },
          on: { click: _vm.closePreviewOptions },
        },
        [
          _c(
            "p",
            {
              staticClass: "bg-g-100-hover",
              staticStyle: {
                margin: "0px",
                height: "24px",
                "line-height": "24px",
                cursor: "pointer",
              },
              on: { click: _vm.downloadFile },
            },
            [_vm._v("保存")]
          ),
          (_vm.previewItem.flow === "out" || _vm.teamOwner == _vm.myAccount) &&
          _vm.lastContextmenuTime - _vm.previewItem.time < 2 * 60 * 1000 &&
          _vm.lastContextmenuTime - _vm.previewItem.time > 0 &&
          _vm.previewItem.from != _vm.previewItem.to
            ? _c(
                "p",
                {
                  staticClass: "bg-g-100-hover",
                  staticStyle: {
                    margin: "0px",
                    height: "24px",
                    "line-height": "24px",
                    cursor: "pointer",
                  },
                  on: { click: _vm.deleteMsg },
                },
                [_vm._v("撤回")]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }